module.exports = __webpack_public_path__ + "static/img/fly-by-fire-lucre-games-lowpoly-skeleton-tiki-tony.8c8fef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-lowpoly-skeleton-tiki-tony.jpg
// module id = G9kQ
// module chunks = 0